import type { CrmRecordType } from "@/lib/api/crm/masters";
import { cn } from "@/lib/utils";
import { recordTypeBadgeClasses, recordTypeLabels } from "../recordTypes";

export function RecordTypeBadge({ type, className }: { type: CrmRecordType; className?: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset",
        recordTypeBadgeClasses[type],
        className,
      )}
    >
      {recordTypeLabels[type]}
    </span>
  );
}
